import { Clock, CreditCard, Gift, Truck } from "react-feather";
//checkout
export const countryMenu = ["Choose...", "U.K", "U.S", "India"];

//pricing
export const pricingContentList = ['50 Email Accounts', 'Maintenance', '15 Subdomains']
export const becomeMemberData = [
    {
        id: 1,
        title: 'Standard',
        amount: 10,
        content: '50GB Disk Space'
    },
    {
        id: 2,
        title: 'Premium',
        amount: 20,
        content: '10% on all product'
    },
    {
        id: 3,
        title: 'Auther pack',
        amount: 50,
        content: 'Upload 50 product'
    },
    {
        id: 4,
        title: 'Auther pack',
        amount: 50,
        content: 'Upload 50 product'
    },
];

export const simplePricingData = [
    {
        id: 1,
        title: 'Standard',
        amount: 15,
        text: 'our preferred plans'
    },
    {
        id: 2,
        title: 'Business',
        amount: 25,
        text: 'ideal for expanding teams'
    },
    {
        id: 3,
        title: 'Premium',
        amount: 35,
        text: 'the most popular of our plans'
    },
    {
        id: 4,
        title: 'Extra',
        amount: 45,
        text: 'optimal for huge teams'
    },
];

export const productColorList = ['primary', 'secondary', 'success', 'info', 'warning'];
export const brandData = ["Clothing", "Bags", "Footwear", "Watches", "Accessories"];
export const productPageMainNav = ['Febric', 'Video', 'Details', 'Brand']

export const productIconList = [
    {
        id: 1,
        link: 'https://www.facebook.com/',
        icon: 'facebook'
    },
    {
        id: 2,
        link: 'https://accounts.google.com/',
        icon: 'google-plus'
    },
    {
        id: 3,
        link: 'https://twitter.com/',
        icon: 'twitter'
    },
    {
        id: 4,
        link: 'https://www.instagram.com/',
        icon: 'instagram'
    },
    {
        id: 5,
        link: 'https://dashboard.rss.com/auth/sign-in/',
        icon: 'rss'
    },
];

export const shippingData = [
    {
        id: 1,
        icon: <Truck />,
        title: 'Free Shipping',
        subTitle: 'Free Shipping World Wide'
    },
    {
        id: 2,
        icon: <Clock />,
        title: '24 X 7 Service',
        subTitle: 'Online Service For New Customer'
    },
    {
        id: 3,
        icon: <Gift />,
        title: 'Festival Offer',
        subTitle: 'New Online Special Festival'
    },
    {
        id: 4,
        icon: <CreditCard />,
        title: 'Online Payment',
        subTitle: 'Contrary To Popular Belief.'
    },
];

export const productPageTab = [
    {
        id: 1,
        paragraph: ['Fabric is a substance made of fibres that have been knitted, woven, or otherwise joined to form a flexible, durable, and multipurpose substance used for clothing and a variety of other purposes. Natural fibres, synthetic fibres, or a combination of both can be used to make fabrics.', "The cotton plant's seed bag is the source of cotton, a natural fibre. It is a popular material for daily wear including t-shirts, shirts, dresses, and undergarments since it is soft, breathable, and comfy.Make sure the video is well-produced and has excellent graphics. To grab the audience's attention, use captivating pictures and original angles."]
    },
    {
        id: 2,
        paragraph: ["A product video's main objective is to illustrate the attributes and functionality of the item. Demonstrate the product in use while emphasising how it satisfies a need or an issue.Include client feedback or testimonials in the video, where appropriate. Genuine customer endorsements may increase credibility and trust.", "You may use software for content production to generate blogs, movies, social media postings, and other things. With the large range of content production software accessible, a number of tools are available. There are certain programmes that let you record and edit video. Others let you to plan out your pieces, do topical research, and come up with fresh content ideas."]
    },
    {
        id: 3,
        paragraph: ["At the conclusion of the video, include a strong and obvious call to action that instructs viewers on what actions to take next, such as visiting a website, making a purchase, or signing up for a newsletter.", "It might be difficult to create new material. While attempting to express oneself artistically, there are numerous factors to consider, including analytics and video quality. Since content creation tools are intended to make the process of creating new material easier, they may relieve some of the headache and lessen your workload."]
    },
    {
        id: 4,
        paragraph: ["Pick audio and background music that supports the message of the video. Ensure that the audio is crystal clear and improves the viewing experience.", "For patients to comprehend and recognise these medications for optimal usage, established/mature brands need a certain level of market familiarity, illness education, and patient engagement with HCPs. During the pandemic, as these companies' income profiles continue to worsen, so do the attention and funding they receive and the already patchy brand recognition they have in the healthcare ecosystem."]
    },
];

//Payment-detals
export const cardListType = ['Select Type', 'Master', 'Visa', 'PayPal', 'COD'];
export const selectMonth = ["Select Month", "Jan", "Fab", "March", "April"];
export const selectYear = ["Select Year", "2023", "2024", "2025", "2026", "2027"];
export const bankName = ["Bank Name", "SBI", "ICICI", "KOTAK", "BOB"];
export const selectDuration = ["Select Duration", "2020-2021", "2021-2022", "2022-2023", "2023-2024"];
export const paymentOption = ["mastercard", "visa", "paypal"];

//cart
export const cartTableHead = ["Product", "Product Name", "Price", "Quantity", "Action", "Total"];
//Add product data
export const addProductNav = [
    {
        id: 1,
        icon: 'product-detail',
        title: 'Add Product Details',
        subTitle: 'Add product name & details'
    },
    {
        id: 2,
        icon: 'product-gallery',
        title: 'Product Gallery',
        subTitle: 'Thumbnail & add product gallery'
    },
    {
        id: 3,
        icon: 'product-category',
        title: 'Product Categories',
        subTitle: 'Add product category, status and tags'
    },
    {
        id: 4,
        icon: 'pricing',
        title: 'Selling Prices',
        subTitle: 'Add product basic price & discount'
    },
    {
        id: 5,
        icon: 'advance',
        title: 'Advance',
        subTitle: 'Add meta details & inventory details'
    },
];

export const productGalleryData = [
    {
        id: 1,
        title: 'Product Image',
        icon: 'file-upload',
        spanText: 'SVG,PNG,JPG or GIF'
    },
    {
        id: 2,
        title: 'Product Gallery',
        icon: 'file-upload1',
        spanText: 'Add Product Gallery Images'
    },
];

export const addCategoryItem = ["Toys & games", "Sportswear", "Jewellery", "Furniture and Decor", "Health, Personal Care, and Beauty", "Auto and Parts", "Baby Care Products"];
export const productTagItem = ["watches", "sports", "clothes", "bottles"];
export const publishStatusItem = ["Publish", "Drafts", "Unpublish"];
export const chooseCurrencyItem = ["Dollar $", "Euro €", "Rupees ₹", "British pounds £", "Russian Ruble ₽", "Japanese Yen ¥", "Singapore Dollar S$"];
export const stockAvailabilityItem = ["In stock", "Out of stock", "Pre-order"]
export const lowStockItem = ["Low Stock (5 or less)", "Low Stock (10 or less)", "Low Stock (20 or less)", "Low Stock (25 or less)", "Low Stock (30 or less)"]
export const stateItem = ["State", "Gujarat", "Punjab", "Himachal pradesh", "Goa", "Sikkim", "Telangana"];
export const basicShippingItem = ["Basic Shipping", "Expedited Shipping", "International Shipping", "Free Shipping", "Same-Day or Next-Day Shipping", "Flat Rate Shipping", "Local Pickup"];

export const sellingPriceRadio = [
    {
        id: 1,
        text: 'Fixed Price'
    },
    {
        id: 2,
        text: 'BOGO(Buy one, Get one)',
        check: 'checked'
    },
    {
        id: 3,
        text: 'Seasonal or holiday discount'
    },
    {
        id: 4,
        text: 'Percentage-based discount(%)'
    },
    {
        id: 5,
        text: 'Volume or bulk discount'
    },
];

//product data
export const gridOptionsData = [
    {
        anchorClass: 2,
        colClass: "col-xl-6 col-sm-6",
        gridLine: ["1", "2"],
    },
    {
        anchorClass: 3,
        colClass: "col-xl-4 col-sm-4",
        gridLine: ["3", "4", "5"],
    },
    {
        anchorClass: 4,
        colClass: "col-xl-3 col-sm-3",
        gridLine: ["6", "7", "8", "9"],
    },
    {
        anchorClass: 6,
        colClass: "col-xl-2 col-sm-2",
        gridLine: ["10", "11", "12", "13", "14", "15"],
    },
];

export const productSize = ['M', 'L', 'XL']

export const productSettings = {
    slidesToShow: 1,
    swipeToSlide: false,
    arrows: true,
    dots: false,
};

export const productSlide1 = [
    {
        image: "01.jpg",
        title: "Woman T-shirt",
        text: "$100.00",
    },
    {
        image: "02.jpg",
        title: "Dream Beauty Fashion",
        text: "$150.00",
    },
    {
        image: "03.jpg",
        title: "VOXATI",
        text: "$200.00",
    },
];

export const productSlide2 = [
    {
        image: "01.jpg",
        title: "Fancy Shirt",
        text: "$100.00",
    },
    {
        image: "02.jpg",
        title: "Fancy Shirt",
        text: "$100.00",
    },
    {
        image: "03.jpg",
        title: "Fancy Shirt",
        text: "$100.00",
    },
];
